import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Button,
  MenuItem,
  Select,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

const TravelersModal = ({ isOpen, handleClose, onTravelersChange, initialTravelers }) => {
  const [rooms, setRooms] = useState(() => {
    if (initialTravelers && initialTravelers.roomDetails && initialTravelers.roomDetails.length > 0) {
      return initialTravelers.roomDetails;
    } else if (initialTravelers && (initialTravelers.adults || initialTravelers.children)) {
      return [{
        adults: initialTravelers.adults || 1,
        children: initialTravelers.children || 0,
        childAges: initialTravelers.childAges || []
      }];
    } else {
      return [{ adults: 1, children: 0, childAges: [] }];
    }
  });

  const handleAdultChange = (roomIndex, value) => {
    const newRooms = [...rooms];
    const newCount = newRooms[roomIndex].adults + value;
    if (newCount >= 1 && newCount <= 4) {
      newRooms[roomIndex].adults = newCount;
      setRooms(newRooms);
      updateTotalTravelers(newRooms);
    }
  };

  const handleRemoveRoom = (roomIndex) => {
    if (rooms.length > 1) {
      const newRooms = rooms.filter((_, index) => index !== roomIndex);
      setRooms(newRooms);
      updateTotalTravelers(newRooms);
    }
  };

  const handleChildChange = (roomIndex, value) => {
    const newRooms = [...rooms];
    const newCount = newRooms[roomIndex].children + value;
    if (newCount >= 0 && newCount <= 4) {
      newRooms[roomIndex].children = newCount;
      if (value > 0) {
        newRooms[roomIndex].childAges.push(0);
      } else {
        newRooms[roomIndex].childAges.pop();
      }
      setRooms(newRooms);
      updateTotalTravelers(newRooms);
    }
  };

  const updateTotalTravelers = (currentRooms) => {
    const totalAdults = currentRooms.reduce(
      (sum, room) => sum + room.adults,
      0
    );
    const totalChildren = currentRooms.reduce(
      (sum, room) => sum + room.children,
      0
    );

onTravelersChange({
  adults: totalAdults,
  children: totalChildren,
  rooms: currentRooms.length,
  roomDetails: currentRooms // Pass full room details including childAges per room
});
  };

  const handleChildAgeChange = (roomIndex, childIndex, age) => {
    const newRooms = [...rooms];
    newRooms[roomIndex].childAges[childIndex] = age;
    setRooms(newRooms);
    updateTotalTravelers(newRooms);
  };

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "white",
          borderRadius: 1,
          p: 3,
          width: "100%",
          maxWidth: 400,
          maxHeight: "90vh",
          overflow: "auto",
        }}
      >
        {rooms.map((room, roomIndex) => (
          <Box key={roomIndex} sx={{ mb: 3 }}>
            <Typography sx={{ fontWeight: 500, mb: 2 }}>
              Room {roomIndex + 1}
            </Typography>

            {/* Adults */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography>Adults</Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <IconButton
                  onClick={() => handleAdultChange(roomIndex, -1)}
                  sx={{ border: "1px solid #ccc", borderRadius: "50%" }}
                >
                  <RemoveIcon />
                </IconButton>
                <Typography>{room.adults}</Typography>
                <IconButton
                  onClick={() => handleAdultChange(roomIndex, 1)}
                  sx={{ border: "1px solid #ccc", borderRadius: "50%" }}
                >
                  <AddIcon />
                </IconButton>
              </Box>
            </Box>

            {/* Children */}
            <Box sx={{ mb: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 1,
                }}
              >
                <Box>
                  <Typography>Children</Typography>
                  <Typography variant="caption" color="text.secondary">
                    Ages 1 to 17
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <IconButton
                    onClick={() => handleChildChange(roomIndex, -1)}
                    sx={{ border: "1px solid #ccc", borderRadius: "50%" }}
                  >
                    <RemoveIcon />
                  </IconButton>
                  <Typography>{room.children}</Typography>
                  <IconButton
                    onClick={() => handleChildChange(roomIndex, 1)}
                    sx={{ border: "1px solid #ccc", borderRadius: "50%" }}
                  >
                    <AddIcon />
                  </IconButton>
                </Box>
              </Box>

              {/* Child Age Dropdowns */}
          {room.childAges.map((age, childIndex) => (
  <Box key={childIndex} sx={{ mt: 1 }}>
    <Typography variant="caption" sx={{ mb: 0.5 }}>
      Child {childIndex + 1} age
    </Typography>
    <Select
      fullWidth
      value={age}
      size="small"
      onChange={(e) =>
        handleChildAgeChange(
          roomIndex,
          childIndex,
          e.target.value
        )
      }
    >
      {[...Array(12)].map((_, i) => {
        const ageValue = i + 1;
        return (
          <MenuItem key={ageValue} value={ageValue}>
            {ageValue} years old
          </MenuItem>
        );
      })}
    </Select>
  </Box>
))}

            </Box>

            {/* {roomIndex > 0 && (
              <Button
                sx={{ color: "#0071c2", textTransform: "none", p: 0 }}
                onClick={() => {
                  const newRooms = rooms.filter(
                    (_, index) => index !== roomIndex
                  );
                  setRooms(newRooms);
                }}
              >
                Remove room
              </Button>
            )} */}
            {rooms.length > 1 && (
              <Button
                sx={{
                  color: "#0071c2",
                  textTransform: "none",
                  p: 0,
                  "&:hover": {
                    backgroundColor: "transparent",
                    textDecoration: "underline",
                  },
                }}
                onClick={() => handleRemoveRoom(roomIndex)}
              >
                Remove room
              </Button>
            )}
          </Box>
        ))}

        <Button
          sx={{ color: "#0071c2", textTransform: "none", p: 0, mb: 2 }}
          onClick={() => {
            const newRooms = [...rooms, { adults: 1, children: 0, childAges: [] }];
            setRooms(newRooms);
            updateTotalTravelers(newRooms);
          }}
        >
          Add another room
        </Button>

        <Box sx={{ bgcolor: "#f5f5f5", p: 2, borderRadius: 1, mb: 2 }}>
          <Typography variant="body2" color="text.secondary">
            Need to book 9 or more rooms?
          </Typography>
        </Box>

        <Button
          fullWidth
          variant="contained"
          onClick={handleClose}
          sx={{
            bgcolor: "#0071c2",
            textTransform: "none",
            "&:hover": { bgcolor: "#005999" },
          }}
        >
          Done
        </Button>
      </Box>
    </Modal>
  );
};

export default TravelersModal;
